// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"3b6ce7c2","308":"bd147e14","453":"baa6b856","692":"925871a1","736":"551edf34","770":"17853d40","815":"f7693401"}[chunkId] + ".chunk.js";
};